import { useCallback, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API } from "../data/siteData";

async function verifySession(sessionId) {
  const sessionResponse = await fetch(`${API}/auth/session`, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ session_id: sessionId }) });
  if (!sessionResponse.ok) throw new Error();
}

async function completeAuthentication(hash, navigate, processed) {
  if (processed.current) return;
  processed.current = true;
  const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
  if (!sessionId) {
    navigate("/investor-portal", { replace: true });
    return;
  }
  try {
    await verifySession(sessionId);
    window.dispatchEvent(new Event("gameday-session-started"));
    navigate("/investor-portal", { replace: true });
  } catch {
    navigate("/investor-portal?auth_error=1", { replace: true });
  }
}

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);
  const completeAuth = useCallback(() => completeAuthentication(location.hash, navigate, processed), [location.hash, navigate]);
  useEffect(() => { completeAuth(); }, [completeAuth]);
  return <main className="portal-state" data-testid="auth-callback-state">Completing secure sign-in…</main>;
}